import { Tutorial } from '../../components';

export function TutorialFirstAccess() {
    return <Tutorial />;
}